import React from "react";
import { withRouter } from 'react-router-dom';
import StandardFormComponent from "../../basics/form/StandardFormComponent";
import FormToastComponent from "../../basics/FormToastComponent";
import FormHelper from "../../../helpers/FormHelper";
import { LoaderComponent } from "../../basics/layout";
import EventOptionGroup from "../../../models/event/EventOptionGroup";
import { EventOptionGroupRepository } from "../../../repository";
import OptionGroupTextFormComponent from "./forms/OptionGroupTextFormComponent";

class OptionGroupFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: new EventOptionGroup(),
            loading: true
        };

        this.table_ref = React.createRef();
    }

    componentDidMount() {
        (this.props.get_promise || Promise.resolve(null))
            .then(group => this.setState({ loading: false, model: group || this.state.model }));
    }

    success = () => {
        FormToastComponent.successTrans("Event", "Default.saved");
        this.props.history.push('/module/events/' + this.props.match.params.module + '/options/' + this.props.match.params.event + '/overview');
    }

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.props}
                ref={this.table_ref}
                parent={this}
                className="event-option-group"
                validationSchema={EventOptionGroup.schema()}
                model={this.state.model}
                formSubmit={(values) => {
                    let data = {
                        event: this.props.match.params.event,
                        type: values.type,
                        required: !!values.required,
                        title: values.title,
                        description: values.description
                    };

                    let promise = this.state.model.id
                        ? EventOptionGroupRepository.update({ ...data, id: this.state.model.id, language: this.props.match.params.language })
                        : EventOptionGroupRepository.create(data);

                    return promise
                        .then(this.success)
                        .catch(error => FormHelper.handleSubmitError(this, error));
                }}
                formErrors={this.state.form_errors}
                fields={OptionGroupTextFormComponent.fields()}
            />
        );
    }
}

export default withRouter(OptionGroupFormComponent);
